<div class="wrapper">
  <div class="count">{{ users.length }}명이 접속중입니다.</div>
  <div class="p-2 detail">
    <p *ngFor="let user of users">
      {{ user }}
    </p>
  </div>
</div>
